import styled from "styled-components";

const StyledFormSelect = styled.select`
    border: solid 1px ${(props) => props.theme.color.bordergray};
    background-color: ${(props) => props.theme.color.white};
    color: ${(props) => props.theme.color.dark};
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    box-sizing: border-box;
    border-radius: 2px;
    font-size: 12px;

    :focus {
        outline: none !important;
        border:1px solid ${(props) => props.validated === undefined ? props.theme.color.primaryblue : ''};
    }

    ${({ validated }) => validated === false && `
        border-color: #dc3545;
        color: #dc3545;
    `}

    ${({ validated }) => validated === true && `
        border-color: #198754;
        color: #198754;
    `}

    :disabled {
        outline: none !important;
        border: 1px solid ${(props) => props.theme.color.bordergray} !important;
        color: ${(props) => props.theme.color.gray} !important;
        background-color: ${(props) => props.theme.color.disabledgray} !important;
        opacity: 1 !important;
    }

    * {
        color: ${(props) => props.theme.color.gray};
    }
`;

function FormSelect(props) {

    const {items, ...restProps} = props;

    return (
        <StyledFormSelect {...restProps}>
            {items.map((item, index) => {
                return (<option value={item} key={index}>{item}</option>);
            })}
        </StyledFormSelect>
    )
}

export default FormSelect;